import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import gtm from '@/utils/gtm';
import './index.scss';

export interface EfNavItemProps {
    /**
     * 点击对应的ID
     */
    href: string;
    /**
     * 标题
     */
    title: string;
    /**
     * key
     */
    key?: string | number;
}
interface EfNavProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    list: EfNavItemProps[];
    /**
     * 是否自动滚动出来active元素
     */
    isAutoScroll?: boolean;
}
const defaultItem: EfNavItemProps = {
    href: '',
    title: '',
};

/**
 * 维护:谢保林
 *
 * 锚点导航
 */
const EfNav: React.FC<EfNavProps> = ({ className, list, isAutoScroll }) => {
    if (!list || !list.length) {
        return null;
    }
    const prefixCls = `ef-nav`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const tabsContainerRef: any = useRef<HTMLDivElement>();
    const activeItemRef = useRef<EfNavItemProps>(list[0] || defaultItem);

    const [activeItem, setActiveItem] = useState<EfNavItemProps>(list[0] || defaultItem);
    // 点击切换
    const toggleItemHandle = (item: EfNavItemProps, index: number) => {
        setTimeout(() => {
            setActiveItem({
                href: item.href,
                title: '',
            });
        }, 800);
        setTimeout(() => {
            tabsContainerRef.current.scrollTo({
                left: 100 * index,
                behavior: 'smooth',
            });
        }, 850);

        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            button_name: item.title,
            list_name: 'none',
        });
    };

    useEffect(() => {
        const offsetH = 200; //距离顶部200px时触发
        const bottomOffset = window.innerHeight - offsetH; //元素
        const theInnerWidth = window.innerWidth;
        const observer = new IntersectionObserver(
            (elems: any) => {
                for (let i = 0; i < elems.length; i++) {
                    const elem = elems[i];
                    const id = `#${elem.target.id}`;
                    const topNum = elem.boundingClientRect.top;

                    const leftNum = tabsContainerRef.current.querySelector(`a[href="${id}"]`)?.getBoundingClientRect()?.left;
                    const rightNum = tabsContainerRef.current.querySelector(`a[href="${id}"]`)?.getBoundingClientRect()?.right;
                    if (elem.isIntersecting && topNum > 0 && topNum <= offsetH && activeItemRef.current.href !== id) {
                        setActiveItem({
                            href: id,
                            title: '',
                        });
                        activeItemRef.current = {
                            href: id,
                            title: '',
                        };
                        // 自动滚动出元素
                        if (isAutoScroll) {
                            if (typeof leftNum === 'number' && leftNum < 0) {
                                const wdis = tabsContainerRef.current.scrollLeft + leftNum;
                                setTimeout(() => {
                                    tabsContainerRef.current.scrollTo({
                                        left: wdis,
                                        behavior: 'smooth',
                                    });
                                }, 50);
                            }

                            if (typeof rightNum === 'number' && rightNum > theInnerWidth && typeof leftNum === 'number' && leftNum > theInnerWidth) {
                                const rightWdis = tabsContainerRef.current.scrollLeft + (rightNum - theInnerWidth);

                                setTimeout(() => {
                                    tabsContainerRef.current.scrollTo({
                                        left: rightWdis,
                                        behavior: 'smooth',
                                    });
                                }, 50);
                            }
                        }
                    } else {
                    }
                }
            },
            {
                rootMargin: `0px 0px -${bottomOffset}px 0px`,
                threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1], //相对于元素自身(自身进入0%,自身进入100%)
            },
        );
        list?.forEach((item: EfNavItemProps, index: number) => {
            try {
                const elem = document.querySelector(item.href);
                if (elem) {
                    observer.observe(elem);
                }
            } catch (error) {}
        });
    }, []);

    return (
        <div className={classes}>
            <div className={`${prefixCls}-in`} ref={tabsContainerRef}>
                {list?.map((item: EfNavItemProps, index: number) => {
                    return (
                        <a
                            href={item.href}
                            key={index}
                            className={`${prefixCls}-item${activeItem.href === item.href ? ` ${prefixCls}-item-active` : ''}`}
                            onClick={() => {
                                toggleItemHandle(item, index);
                            }}
                        >
                            <span className={`${prefixCls}-item-text`}>{item.title}</span>
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default EfNav;
